module.exports = __webpack_public_path__ + "img/fashion_86.06296be2.jpg";